import type { ProfileBirthday } from "@couples/shared";

import { supabase } from "./supabase";

interface ProfileBirthdayRow {
  id: string;
  display_name: string;
  birth_date: string | null;
}

/**
 * カップル二人ぶんのプロフィール(誕生日を含む)。
 *
 * RLS の `profiles_select` が「同じ couple_id の全員」を返すため、
 * 絞り込まずに引けば相手ぶんも含めて取れる(→ lib/media/members.ts と同じ理由)。
 */
export async function fetchBirthdays(): Promise<ProfileBirthday[]> {
  const { data, error } = await supabase.from("profiles").select("id, display_name, birth_date");
  if (error) throw error;
  const rows: ProfileBirthdayRow[] = data;
  return rows.map((row) => ({
    id: row.id,
    displayName: row.display_name,
    birthDate: row.birth_date,
  }));
}
